import {
  kRallyApproach,
  kRallyBounceOverhead,
  kRallyDrive,
  kRallyDriveVolley,
  kRallyDropshot,
  kRallyDropVolley,
  kRallyFlat,
  kRallyHalfVolley,
  kRallyKick,
  kRallyLob,
  kRallyOutcomeForcingError,
  kRallyOutcomeIn,
  kRallyOutcomeNetted,
  kRallyOutcomeOutPassingShot,
  kRallyOutcomePassingShot,
  kRallyOutcomePutAway,
  kRallyOutcomeUnforcedError,
  kRallyOutcomeWinner,
  kRallyOverhead,
  kRallyPassingShot,
  kRallyPowerShot,
  kRallyServeVolley,
  kRallySlice,
  kRallySmash,
  kRallyTopspin,
  kRallyVolley,
  kRallyVolleyPoach,
  kReturnForcingError,
  kReturnIn,
  kReturnUnforcedError,
  kReturnWinner,
  kServeAce,
  kServeFootfault,
  kServeIn,
  kServeLet,
  kServeNet,
  kServeOut,
  kServeWinner
} from "../../utils/pstsDefines";
import EventDetailSelector from "./EventDetailSelector";

function EventEditor({
  isPortrait,
  event,
  isCurrentEvent,
  player1,
  player2,
  isDoubles,
  doublesPlayers,
  onPlayerChanged,
  onHandChanged,
  onSubskill2Changed,
  onOutcomeChanged,
  onServeChanged,
  onReachChanged,
  onServeFormationChanged,
  onNetPositionChanged,
  onReturnFormationChanged,
}) {
  const serves = ["1st Serve", "2nd Serve"];
  const hands = ["Forehand", "Backhand"];
  const outcomes = [
    ["In", "Footfault", "Ace", "Winner", "Let", "Out", "Net"],
    ["In", "Unforced Error", "Forced Error", "Winner"],
    [
      "In",
      "Winner",
      "Unforced Error",
      "Forced Error",
      "Passing Winner",
      "Passing Out",
      "Netted",
      "Put Away",
    ],
    [
      "In",
      "Winner",
      "Unforced Error",
      "Forced Error",
      "Passing Winner",
      "Passing Out",
      "Netted",
      "Put Away",
    ],
  ];

  const subskills2 = [
    [],
    ["Drive", "Slice", "Topspin","Approach", "Lob", "Drop", "Power", "Flat", "Kick"],
    [
      "Slice",
      "Topspin",
      "Volley",
      "Overhead",
      "Smash",
      "Lob",
      "Drop",
      "Drive Volley",
      "Half Volley",
      "Serve Volley",
      "Approach",
      "Attempted Pass",
      "Power",
      "Flat",
      "Kick",
      "Drop Volley",
      "Poach Volley",
      "Bounce Overhead",
    ],
    [
      "Slice",
      "Topspin",
      "Volley",
      "Overhead",
      "Smash",
      "Lob",
      "Drop",
      "Drive Volley",
      "Half Volley",
      "Serve Volley",
      "Approach",
      "Attempted Pass",
      "Power",
      "Flat",
      "Kick",
      "Drop Volley",
      "Poach Volley",
      "Bounce Overhead",
    ],
  ];

  const reach = ["Balanced", "Unbalanced", "Time Poor", "N/A"];

  // Doubles-only: shown for serve events (Serve Formation + Net Position of
  // the non-hitting partner) and return events (Return Formation) — see
  // CodingPage.jsx's doServeFormationChanged/doNetPositionChanged/
  // doReturnFormationChanged.
  const serveFormations = ["Traditional", "Eye", "Squeeze", "Tandem", "2 Back"];
  const netPositions = ["Hold", "Switch", "Cover Middle", "Left", "Right"];
  const returnFormations = ["Traditional", "2 Back"];

  const getOutcomeIndex = (outcome) => {
    const serveoutcomes = [
      kServeIn,
      kServeFootfault,
      kServeAce,
      kServeWinner,
      kServeLet,
      kServeOut,
      kServeNet,
    ];
    const returnoutcomes = [
      kReturnIn,
      kReturnUnforcedError,
      kReturnForcingError,
      kReturnWinner,
    ];
    const rallyoutcomes = [
      kRallyOutcomeIn,
      kRallyOutcomeWinner,
      kRallyOutcomeUnforcedError,
      kRallyOutcomeForcingError,
      kRallyOutcomePassingShot,
      kRallyOutcomeOutPassingShot,
      kRallyOutcomeNetted,
      kRallyOutcomePutAway,
    ];

    if (event.skill === 0) {
      const idx = serveoutcomes.indexOf(outcome);
      return idx;
    } else if (event.skill === 1) {
      const idx = returnoutcomes.indexOf(outcome);
      return idx;
    } else if (event.skill === 2 || event.skill === 3) {
      const idx = rallyoutcomes.indexOf(outcome);
      return idx;
    }
    return 0;
  };

  // Outcomes that are interchangeable WITHOUT changing the point's actual
  // result (winner stays a winner, error stays an error, …) — mirrors
  // CodingPage.jsx's RELABEL_GROUPS/doOutcomeChangedForSelected, which is the
  // function that ultimately enforces this; keep both in sync.
  const RELABEL_GROUPS = {
    0: [
      [kServeFootfault, kServeNet],
      [kServeAce, kServeWinner],
    ],
    1: [[kReturnUnforcedError, kReturnForcingError]],
    2: [
      [kRallyOutcomeWinner, kRallyOutcomePassingShot, kRallyOutcomePutAway],
      [
        kRallyOutcomeUnforcedError,
        kRallyOutcomeForcingError,
        kRallyOutcomeOutPassingShot,
        kRallyOutcomeNetted,
      ],
    ],
  };
  RELABEL_GROUPS[3] = RELABEL_GROUPS[2];

  const canRelabelOutcome = (skill, fromOutcome, toOutcome) => {
    const groups = RELABEL_GROUPS[skill] ?? [];
    return groups.some(
      (g) => g.includes(fromOutcome) && g.includes(toOutcome),
    );
  };

  // For a PAST (non-current) event, only outcomes in the same class as its
  // existing one are selectable — changing the actual result would require
  // undoing back to that point and re-coding it instead. Returns an array of
  // booleans (one per item in `outcomes[event.skill]`) or null when nothing
  // should be disabled (the live current event can be freely re-coded).
  const getOutcomeDisabledItems = () => {
    if (isCurrentEvent) return null;
    const serveoutcomes = [
      kServeIn,
      kServeFootfault,
      kServeAce,
      kServeWinner,
      kServeLet,
      kServeOut,
      kServeNet,
    ];
    const returnoutcomes = [
      kReturnIn,
      kReturnUnforcedError,
      kReturnForcingError,
      kReturnWinner,
    ];
    const rallyoutcomes = [
      kRallyOutcomeIn,
      kRallyOutcomeWinner,
      kRallyOutcomeUnforcedError,
      kRallyOutcomeForcingError,
      kRallyOutcomePassingShot,
      kRallyOutcomeOutPassingShot,
      kRallyOutcomeNetted,
      kRallyOutcomePutAway,
    ];
    const list =
      event.skill === 0
        ? serveoutcomes
        : event.skill === 1
          ? returnoutcomes
          : rallyoutcomes;
    return list.map(
      (oc) => oc !== event.outcome && !canRelabelOutcome(event.skill, event.outcome, oc),
    );
  };

  // Doubles: every shot is attributed to one of the 4 individuals (not a
  // team), so the picker lists all 4 rather than the usual 2 team buttons.
  const playerButtons = isDoubles
    ? doublesPlayers.filter(Boolean)
    : [player1, player2];

  const doPlayerChanged = (selitem) => {
    onPlayerChanged(playerButtons[selitem]);
  };

  const selectedPlayerIndex = () => {
    if (!isDoubles) return event.player === player1 ? 0 : 1;
    const guid = event.individualPlayer?.guid ?? event.individualPlayerGuid;
    const idx = playerButtons.findIndex((p) => p.guid === guid);
    return idx >= 0 ? idx : 0;
  };

  const doServeChanged = (selitem) => {
    onServeChanged(selitem);
  };

  const doHandChanged = (selitem) => {
    onHandChanged(selitem);
  };

  const doSubskill2Changed = (selitem) => {
    onSubskill2Changed(selitem);
  };

  const doOutcomeChanged = (selitem) => {
    onOutcomeChanged(selitem);
  };

  const doReachChanged = (selitem) => {
    onReachChanged(selitem);
  };

  const doServeFormationChanged = (selitem) => {
    onServeFormationChanged(selitem);
  };

  const doNetPositionChanged = (selitem) => {
    onNetPositionChanged(selitem);
  };

  const doReturnFormationChanged = (selitem) => {
    onReturnFormationChanged(selitem);
  };

  const selectedSubskill2Index = (event) => {
    const returnss2 = [
      kRallyDrive,
      kRallySlice,
      kRallyTopspin,
      kRallyApproach,
      kRallyLob,
      kRallyDropshot,
      kRallyPowerShot,
      kRallyFlat,
      kRallyKick,
    ];
    const rallyss2 = [
      kRallySlice,
      kRallyTopspin,
      kRallyVolley,
      kRallyOverhead,
      kRallySmash,
      kRallyLob,
      kRallyDropshot,
      kRallyDriveVolley,
      kRallyHalfVolley,
      kRallyServeVolley,
      kRallyApproach,
      kRallyPassingShot,
      kRallyPowerShot,
      kRallyFlat,
      kRallyKick,
      kRallyDropVolley,
      kRallyVolleyPoach,
      kRallyBounceOverhead,
    ];

    if (event.skill === 1) {
      const idx = returnss2.indexOf(event.subskill2);
      return idx;
    } else if (event.skill === 2 || event.skill === 3) {
      const idx = rallyss2.indexOf(event.subskill2);
      return idx;
    }
    return 0;
  };

  // useEffect(() => {
  //   console.log(event);
  // }, [event && event.hand]);

  if (event === null) {
    return <></>;
  }

  return (
    <>
      <div className="flex-col space-y-1 bg-base-100 rounded-md">
        {isPortrait ? (
          <>
            <div className="w-full">
              <EventDetailSelector
                items={playerButtons.map(
                  (p) => p.firstName.substring(0, 1) + ". " + p.lastName,
                )}
                selectedItem={selectedPlayerIndex()}
                onSelectionChanged={(selitem) => doPlayerChanged(selitem)}
              />
            </div>
            <div className="w-full">
              <EventDetailSelector
                items={event.skill === 0 ? serves : hands}
                selectedItem={event.skill === 0 ? event.subskill1 : event.hand}
                selectedSubitem={
                  event.skill === 0 ? event.subskill1 : event.hand
                }
                onSelectionChanged={
                  event.skill === 0
                    ? (selitem) => doServeChanged(selitem)
                    : (selitem) => doHandChanged(selitem)
                }
              />
            </div>
          </>
        ) : (
          <>
            <div className="flex gap-2 w-full">
              <div className="">
                <EventDetailSelector
                  items={playerButtons.map(
                    (p) => p.firstName.substring(0, 1) + ". " + p.lastName,
                  )}
                  selectedItem={selectedPlayerIndex()}
                  onSelectionChanged={(selitem) => doPlayerChanged(selitem)}
                />
              </div>
              <div className="">
                <EventDetailSelector
                  items={event.skill === 0 ? serves : hands}
                  selectedItem={
                    event.skill === 0 ? event.subskill1 : event.hand
                  }
                  selectedSubitem={
                    event.skill === 0 ? event.subskill1 : event.hand
                  }
                  onSelectionChanged={
                    event.skill === 0
                      ? (selitem) => doServeChanged(selitem)
                      : (selitem) => doHandChanged(selitem)
                  }
                />
              </div>
            </div>
          </>
        )}
        <div className="w-full">
          <EventDetailSelector
            items={outcomes[event.skill]}
            selectedItem={getOutcomeIndex(event.outcome)}
            onSelectionChanged={(selitem) => doOutcomeChanged(selitem)}
            disabledItems={getOutcomeDisabledItems()}
          />
        </div>
        <div className="w-full">
          <EventDetailSelector
            items={subskills2[event.skill]}
            selectedItem={selectedSubskill2Index(event)}
            onSelectionChanged={(selitem) => doSubskill2Changed(selitem)}
          />
        </div>
        {event.skill === 0 ? (
          <></>
        ) : (
          <div className="w-full">
            <EventDetailSelector
              items={reach}
              selectedItem={event.reach}
              onSelectionChanged={(selitem) => doReachChanged(selitem)}
            />
          </div>
        )}
        {isDoubles && event.skill === 0 && (
          <>
            <div className="w-full">
              <EventDetailSelector
                items={serveFormations}
                selectedItem={event.serveFormation ?? 0}
                onSelectionChanged={(selitem) => doServeFormationChanged(selitem)}
              />
            </div>
            <div className="w-full">
              <EventDetailSelector
                items={netPositions}
                selectedItem={event.netPosition ?? 0}
                onSelectionChanged={(selitem) => doNetPositionChanged(selitem)}
              />
            </div>
          </>
        )}
        {isDoubles && event.skill === 1 && (
          <div className="w-full">
            <EventDetailSelector
              items={returnFormations}
              selectedItem={event.returnFormation ?? 0}
              onSelectionChanged={(selitem) => doReturnFormationChanged(selitem)}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default EventEditor;
